import { createElementBlock as c, openBlock as l, createElementVNode as t } from "vue";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const n = {}, r = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function h(m, e) {
  return l(), c("svg", r, e[0] || (e[0] = [
    t("rect", {
      fill: "#79A92E",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    t("path", {
      "clip-rule": "evenodd",
      d: "M14.757 14.688H5.243c-.824 0-1.493-.729-1.493-1.625V6.936c0-.895.67-1.624 1.493-1.624h9.514c.824 0 1.493.729 1.493 1.624v6.127c0 .896-.67 1.624-1.493 1.624ZM5.243 6.142c-.402 0-.73.356-.73.794V8.15h2.624V6.142H5.243Zm2.829 0h3.856V8.15H8.072V6.142Zm0 2.838h3.856v2.018H8.072V8.98Zm-.935 0H4.513v2.018h2.624V8.98Zm0 2.848H4.513v1.235c0 .438.328.794.73.794h1.894v-2.029Zm.935 2.029h3.856v-2.029H8.072v2.029Zm4.791-4.877v2.018h2.623V8.98h-2.623Zm0 2.848v2.029h1.894c.402 0 .729-.356.729-.794v-1.235h-2.623Zm0-5.686V8.15h2.623V6.936c0-.438-.327-.794-.729-.794h-1.894Z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = /* @__PURE__ */ o(n, [["render", h]]);
export {
  i as default
};
